import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_APPROVAL_TYPES_QUERY = gql`
  query pagedApprovalTypes($pager: PagerInputNew, $filters: ApprovalTypesFilterInput) {
    pagedApprovalTypes(pager: $pager, filters: $filters) {
      total
      values {
        ...approvalType
      }
    }
  }
  ${Fragments.approvalType}
`;

export const APPROVAL_TYPES_FILTERS_QUERY = gql`
  {
    approvalTypeListFilters @client {
      fullTextFilter {
        value
      }
      approvalTypeName {
        value
      }
      approvalTypeCode {
        value
      }
    }
  }
`;
